import { Anchor, Button, type ErrorPageProps, getLocaleAsset } from "../..";

export function ServerErrorContent({ error, reset }: ErrorPageProps) {
	return (
		<div className="flex min-h-dvh flex-col items-center justify-center gap-8 md:flex-row">
			<div className="prose">
				<h1 className="font-extrabold text-9xl text-primary-medium">500</h1>
				<h2>An error occurred</h2>

				{!!error.digest && (
					<p>
						<i>{error.digest}</i>
					</p>
				)}

				<ol>
					<li>
						<Button variant="link" onClick={reset}>
							Try again
						</Button>
					</li>
					<li>
						<Button variant="link" onClick={() => history.back()}>
							Go back
						</Button>
					</li>
					<li>
						<Anchor href="/">Go home</Anchor>
					</li>
					<li>
						<Anchor href="/contacts">Contact us</Anchor>
					</li>
				</ol>
			</div>

			<img
				className="max-h-48 w-auto"
				src={getLocaleAsset("Karakters/hans_search.png")}
				width={801}
				height={651}
				alt=""
			/>
		</div>
	);
}
